export default __webpack_public_path__ + "static/media/CNo.86-2.b92da052.jpg";